import React from 'react';
import DrillOver from '../../shared/DrillOver';
import { fmtNumber } from '../kit';
import RailRow from './RailRow';
import { isOpenRequest, requestMetaParts, sortRequests } from './RequestsCard';

/**
 * "All requests →": every request this client has made, open ones first, longest wait first,
 * in the app's one slide-over. The rows are the ones the page already loaded (the whole
 * v_client_requests list for this client), so nothing is fetched and the page's search does
 * not narrow it.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {object[]} [props.requests]  Unfiltered v_client_requests rows.
 */
export default function RequestsSheet({ open, onClose, requests }) {
  if (!open) return null;
  const rows = sortRequests(requests);
  const stillOpen = rows.filter(isOpenRequest).length;
  const body = rows.length === 0 ? (
    <p className="py-4 text-sm text-gray-500 dark:text-gray-400">No recorded requests from this client.</p>
  ) : (
    <div className="space-y-2.5" data-testid="requests-sheet-rows">
      {rows.map((r, i) => (
        <RailRow
          key={r?.task_id || `${r?.requested_by}-${r?.title}-${i}`} testId="requests-sheet-row" rail={isOpenRequest(r) ? 'warn' : 'neutral'}
          title={r?.title || 'An unnamed request'} meta={requestMetaParts(r)}
        />
      ))}
    </div>
  );
  return (
    <DrillOver
      stack={[{
        label: 'All requests',
        subtitle: `${fmtNumber(rows.length)} ${rows.length === 1 ? 'request' : 'requests'} · ${fmtNumber(stillOpen)} still open`,
        body,
      }]}
      onBack={onClose}
      onClose={onClose}
    />
  );
}
